import { Pipe, PipeTransform } from '@angular/core';
import { EnvironmentService } from '@services/environment/environment.service';
import { VIRTUAL_FILES_SUB_PATH } from '@core/config';
import { DocumentMeta } from '@models/interfaces';

const TRANSFORM_MODE = {
  REGULAR: 'REGULAR',
  REVERSE: 'REVERSE',
} as const;

type VirtualPathTransformMode = keyof typeof TRANSFORM_MODE;

@Pipe({
  name: 'virtualPath',
  standalone: true,
})
export class VirtualPathPipe implements PipeTransform {
  static instance: VirtualPathPipe;

  static transform(
    href: string,
    options: Partial<{
      mode: VirtualPathTransformMode;
      provideCmsPath: boolean;
      documentMeta: Partial<DocumentMeta>;
    }> = {}
  ): string {
    VirtualPathPipe.instance ||= new VirtualPathPipe();
    return VirtualPathPipe.instance.transform(href, options);
  }

  public transform(
    href: string = null,
    options: Partial<{
      mode: VirtualPathTransformMode;
      provideCmsPath: boolean;
      documentMeta: Partial<DocumentMeta>;
    }> = {}
  ): string {
    const mode = options?.mode || 'REGULAR';
    const provideCmsPath = options?.provideCmsPath ?? false;
    const documentMeta = options?.documentMeta ?? null;

    if (!href) {
      return href;
    }

    return mode === 'REGULAR' ? this.regularTransform(href, provideCmsPath, documentMeta) : this.reverseTransform(href);
  }

  private regularTransform(href: string, provideCmsPath = false, documentMeta: Partial<DocumentMeta> = {}): string {
    if (!href.toLowerCase().endsWith('pdf')) {
      return href;
    }

    href = decodeURIComponent(href);

    if (provideCmsPath) {
      const source = EnvironmentService.apiHost;
      const target = EnvironmentService.cmsHost;

      return href.replace(source, target);
    }

    const filepath = href.split('files/').at(-1);
    const filepathWithoutExtension = filepath.split('.pdf')[0];
    const url = new URL([EnvironmentService.host, 'site', 'files', 'pdfs', filepathWithoutExtension].join('/'));

    try {
      url.searchParams.set('meta', btoa(encodeURIComponent(JSON.stringify(documentMeta))));
    } catch (e) {
      debugger;
    }

    return url.toString();
  }

  private reverseTransform(href: string): string {
    const url = new URL(href);
    return url.pathname.replace('/sites/default/files', VIRTUAL_FILES_SUB_PATH);
  }
}
